import { render, staticRenderFns } from "./SystemDepartment.vue?vue&type=template&id=247d7d18&"
import script from "./SystemDepartment.vue?vue&type=script&lang=js&"
export * from "./SystemDepartment.vue?vue&type=script&lang=js&"
import style0 from "./SystemDepartment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports